
import general from './general';
import home from './home';
import campaign from './campaign';
import partners from './partners';
import influencer from './influencer';
import contact from './contact';
import admin from './admin';
import affiliate from './affiliate';

export default {
  ...general,
  ...home,
  ...campaign,
  ...partners,
  ...influencer,
  ...contact,
  ...admin,
  ...affiliate,
} as const;
